<template>
  <div class="flex w-full">
    <div class="aspect-1 w-[90px] flex-shrink-0 lg:w-[118px]">
      <UiLazyImg
          :src="product?.image_url || '/images/no-image.webp'"
          :alt="product.currentTranslation?.title"
      />
    </div>

    <div class="my-0 ml-4 flex w-full justify-between max-sm:flex-col">
      <div class="space-y-2.5">
        <div>
            <span
              v-if="
                !isReturn &&
                ((product?.qty && Number(product?.qty) > 1) ||
                (product?.quantity && Number(product?.quantity) > 1))
              "
              class="text-gray-details"
            >
              {{ product?.qty || product?.quantity }}x
            </span>
            <span
              v-if="isReturn && (product?.quantityAvailableToReturn && Number(product?.quantityAvailableToReturn) > 1)"
              class="text-gray-details"
            >
              {{ product.quantityAvailableToReturn }}x
            </span>
          {{ product?.configuration_title || product?.currentTranslation?.title }}
        </div>

        <div
          v-if="product?.status_title"
          class="ui-text-sm inline-flex h-7.5 items-center self-center rounded-full bg-order-label px-6 text-primary"
        >
          {{ product.status_title }}
        </div>

        <ul class="text-xs text-gray-details">
          <li>
            <span class="capitalize">{{ $t("sku") }}</span>:
            {{ product.vendor_model }}
          </li>
          <li v-if="product.options.engagement">
            {{
              product.options?.engagement?.product_type === "product"
                ? "Diamond SKU: "
                : "Ring SKU: "
            }}
            {{
              product.options.engagement?.product_type === "product"
                ? product.options?.engagement?.dsku
                : product.options?.engagement?.psku
            }}
          </li>
          <template
            v-if="
              product &&
              product.categories?.some((el) => el.sku === diamondSku)
            "
          >
            <li
              v-for="(material, idx) in filteredMaterials(product)"
              :key="idx"
            >
              {{ material.material_category_title }}: {{ material.title }}
            </li>
          </template>
          <template v-else>
            <li
              v-for="material in productMaterials(product)"
              :key="material.id"
            >
              {{ material.material_category_title }}: {{ material.title }}
            </li>
          </template>
        </ul>
      </div>

      <div class="font-light text-gray-elements max-sm:pt-2.5">
        {{
          $n(
            Number(
                product?.sale ? product?.sale_cost : product?.base_cost,
            ),
            "currency",
          )
        }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CartItem } from "ecom-types";
import {diamondMaterialsShowListSKU, diamondSku} from "~/configs";

const props = defineProps<{
  product: CartItem & { quantityAvailableToReturn?: number };
  isExpanded: boolean;
  isReturn: boolean;
}>();

const generalStore = useGeneralStore();

function filteredMaterials(product: CartItem) {
  if (!product?.materials.length) {
    return [];
  }
  const res = product.materials.reduce(
    (acc, block) => {
      const constant = diamondMaterialsShowListSKU.find(
        (el) => block.category_sku === el.sku,
      );

      const currentCategory = generalStore.bootstrap?.material_categories?.find(
        (mat) => mat.id === block.category_id,
      );
      if (constant) {
        acc.push({
          title: block?.currentTranslation?.title,
          material_category_title: currentCategory?.currentTranslation?.title,
          order: constant.order,
        });
      }
      return acc;
    },
    <any>[],
  );
  res.sort((a: any, b: any) => a.order - b.order);
  return res;
}

function productMaterials(product: CartItem) {
  return product.materials.map((material) => {
    const currentCategory = generalStore.bootstrap?.material_categories?.find(
      (mat) => mat.id === material.category_id,
    );
    return {
      ...material,
      material_category_title: currentCategory?.currentTranslation.title,
    };
  });
}
</script>
